/**
 * Dates civiles réunionnaises.
 *
 * La Réunion est en UTC+4 : `toISOString()` sur un instant local renvoie la
 * veille en début de journée, ce qui ferait basculer un anniversaire et donc la
 * minorité. Tout ce qui se raisonne en jour civil passe par ici.
 */

/**
 * Jour courant au format `AAAA-MM-JJ`, heure de La Réunion.
 *
 * Recalculé à chaque appel : un onglet laissé ouvert plusieurs jours garderait
 * sinon la borne de son premier chargement.
 */
export function aujourdhui(): string {
  return jourCivilReunion(new Date());
}

/** Jour civil réunionnais (`AAAA-MM-JJ`) d'un instant ; `slice(0, 10)` donnerait celui de Greenwich. */
export function jourCivilReunion(instant: Date | string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Indian/Reunion' }).format(new Date(instant));
}

/**
 * Minorité à l'entrée en formation.
 *
 * C'est un indice d'écran, pas la donnée du dossier : l'API recalcule et fait
 * foi. Le calcul se fait sur les chaînes `AAAA-MM-JJ` telles que saisies, sans
 * passer par un `Date` — construire un instant depuis une date civile
 * réunionnaise décale d'un jour. Faute de date d'entrée, la référence est le
 * jour même.
 */
export function minoriteALEntree(dateNaissance?: string, dateEntree?: string): boolean {
  if (!dateNaissance) return false;
  const reference = dateEntree && dateEntree !== '' ? dateEntree : aujourdhui();
  const [anneeN, moisN, jourN] = dateNaissance.split('-').map(Number);
  const [anneeR, moisR, jourR] = reference.split('-').map(Number);
  if (!anneeN || !moisN || !jourN || !anneeR || !moisR || !jourR) return false;

  let age = anneeR - anneeN;
  if (moisR < moisN || (moisR === moisN && jourR < jourN)) age -= 1;
  return age < 18;
}
